<template>
  <div class="supplyair-container">
    <highcharts
      class="chart"
      :options="chartOptions"
    />
  </div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';

export default {
  name: 'SupplyAirGraph',
  props: {
    graphData: Array,
    status: String,
    type: String,
  },
  data() {
    const supplyAirData = [];
    const cycleDate = [];
    const newGraphData = _.cloneDeep(this.graphData);
    const sortedData = newGraphData.sort((a, b) => moment(a.startTime).diff(b.startTime));

    sortedData.forEach((c) => {
      const {
        supplyAir,
        startTime,
      } = c;

      const color = this.status === 'Watching' ? '#FFAB00' : '#FF5B52';
      const radius = this.status === 'Watching' ? '#FFDD99' : '#F9BDBA';

      if (this.type === 'Cool Supply Air' && startTime) {
        if (supplyAir && supplyAir.minTemp) {
          supplyAirData.push({
            y: supplyAir.minTemp,
            marker: {
              fillColor: color,
              lineColor: radius,
            },
          });
          cycleDate.push(moment(startTime).format('M/D/YY h:mm:ss a'));
        }
      } else if (this.type === 'Heat Supply Air' && startTime) {
        if (supplyAir && supplyAir.maxTemp) {
          supplyAirData.push({
            y: supplyAir.maxTemp,
            marker: {
              fillColor: color,
              lineColor: radius,
            },
          });
          cycleDate.push(moment(startTime).format('M/D/YY h:mm:ss a'));
        }
      }
    });

    return {
      supplyAirData,
      cycleDate,
    };
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          type: 'area',
          spacingTop: 0,
          spacingBottom: 0,
          spacingLeft: 0,
          spacingRight: 0,
          height: 360,
          width: 470,
          events: {
            load() {
              this.seriesGroup.element.insertBefore(
                this.yAxis[0].gridGroup.element,
                this.series[0].markerGroup.element,
              );
            },
          },
          backgroundColor: 'transparent',
        },
        title: {
          text: '',
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          style: {
            display: 'none',
          },
          animation: false,
        },
        exporting: {
          enabled: false,
        },
        xAxis: {
          categories: this.cycleDate,
          lineWidth: 0,
          labels: {
            formatter() {
              const label = this.value;
              const date = moment(label).format('M/D/YY');
              const time = moment(label).format('hh:mm:ss A');
              return `${date}<br>${time}`;
            },
          },
        },
        yAxis: {
          gridLineColor: 'white',
          gridLineDashStyle: 'Dash',
          gridLineWidth: 0,
          title: {
            text: '',
          },
          labels: {
            enabled: false,
          },
          min: 0,
          max: 100,
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            connectNulls: true,
            threshold: -Infinity,
            lineColor: '#e8edfe',
            lineWidth: 1,
            dataLabels: {
              enabled: true,
              align: 'center',
              y: 1000,
              color: 'black',
              format: '{y}°',
              style: {
                textOutline: 0,
                zIndex: 6,
                fontWeight: 'bold',
                fontSize: 15,
              },
            },
            fillColor: {
              linearGradient: {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 1,
              },
              stops: [
                [0, 'rgba(73, 121, 255, 0.15)'],
                [1, 'rgba(73, 121, 255, 0)'],
              ],
            },
            marker: {
              lineWidth: 2,
              radius: 7,
              symbol: 'circle',
            },
          },
        },
        series: [{
          data: this.supplyAirData,
        }],
      };
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
